module.exports = __webpack_public_path__ + "static/media/avatar.0d379bc3.png";